import _ from 'lodash';
import * as ActionType from '../../core/ActionType';
import InitialState from '../../core/InitialState'

/**
 * 
 * @param {Estado} state 
 * @param {Ação} action 
 */
const tipoPagamentoReducer = (state = InitialState.tipoPagamentoReducer, action) => {
    switch (action.type) {
        case ActionType.GET_TIPO_PAGAMENTO_RESPONSE: {
            return {
                ...state,
                tipoPagamentoObject: _.assign(action.tipoPagamentoObject),
                error: _.assign(action.error)
            }
        }
        default: { return state; }
    }
}

export default tipoPagamentoReducer;